/* Late loader: defers heavy third-parties until consent + first interaction */
(function(){
  function loadScript(d){ 
    return new Promise(function(res, rej){
      if (!d || !d.src) return res();
      if (document.querySelector('script[src="'+d.src+'"]')) return res();
      var s = document.createElement('script');
      s.src = d.src;
      if (d.async) s.async = true; else s.defer = true;
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  function arm(){
    if (arm.armed) return; arm.armed = true;
    if (!window.__perfConsent){ return; } // respect marketing consent / logged in
    var arr = (window.__LATE_SCRIPTS || []);
    var i = 0;
    (function next(){ if (i>=arr.length) return; loadScript(arr[i++]).then(()=>setTimeout(next, 200)); })();
  }
  ['scroll','mousemove','keydown','touchstart'].forEach(ev=>window.addEventListener(ev, arm, {once:true, passive:true}));
  if (document.readyState !== 'loading') setTimeout(arm, 1200); else document.addEventListener('DOMContentLoaded', ()=>setTimeout(arm, 1200));
})();
